
define('hbs!app/visualizations/MonitorNameCell.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<h4 class=\"report-name\">\n	<a href=\"/domains/"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.namelink : depth0)) != null ? stack1.domainId : stack1), depth0))
    + "/monitors/"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.namelink : depth0)) != null ? stack1.id : stack1), depth0))
    + "\" title=\""
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.namelink : depth0)) != null ? stack1.name : stack1), depth0))
    + "\" data-qa=\""
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.namelink : depth0)) != null ? stack1.name : stack1), depth0))
    + "\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.namelink : depth0)) != null ? stack1.name : stack1), depth0))
    + "</a>\n</h4>";
},"useData":true});Handlebars.registerPartial('app/visualizations/MonitorNameCell.hbs', t);return t;});
